import { render, staticRenderFns } from "./titleStyle.vue?vue&type=template&id=324d31de&scoped=true&"
import script from "./titleStyle.vue?vue&type=script&lang=js&"
export * from "./titleStyle.vue?vue&type=script&lang=js&"
import style0 from "./titleStyle.vue?vue&type=style&index=0&id=324d31de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d31de",
  null
  
)

export default component.exports